export const isEmpty = (object: Record<string, unknown>): boolean => {
  return Object.keys(object).length === 0;
};

export const lastKey = (object: Record<string, unknown>): string | undefined => {
  return Object.keys(object)[Object.keys(object).length - 1];
};

export const firstKey = (object: Record<string, unknown>): string | undefined => {
  return Object.keys(object)[0];
};

export function objectToQueryString(obj: Record<string, unknown>, prefix: string = ''): string {
  const query = [];

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      const newKey = prefix ? `${prefix}[${key}]` : key;

      if (typeof value === 'object' && value !== null) {
        query.push(objectToQueryString(value, newKey));
      } else {
        query.push(`${encodeURIComponent(newKey)}=${encodeURIComponent(value)}`);
      }
    }
  }

  return query.join('&');
}

export function removeNullish<T extends Record<string, unknown>>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]): value is NonNullable<unknown> => {
      if (value == null) return false;
      if (value === '') return false;
      if (Array.isArray(value) && value.length === 0) return false;
      return true;
    })
  ) as Partial<T>;
}
